import React, { useState } from 'react';
import { TextField, Link } from '@mui/material';
import { getUserByEmail, login, verificarUsuarioPorCorreo } from "../services/login";
import { useNavigate } from 'react-router-dom';
import '../components/AceternityForm/AceternityForm.css';
import { aceternityTextFieldSx } from '../components/AceternityForm/aceternityTextFieldSx';
import BorderGlow from '../components/BorderGlow/BorderGlow';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { useUser } from '../Context/UserContext'; // Importamos el contexto
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'; // Importamos GoogleLogin

export default function SignInPage() {
    const { setUser, user } = useUser(); // Obtener la función para actualizar el usuario y el estado del usuario
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!userName || !password) {
            setErrorMessage('Por favor, complete todos los campos.');
            return;
        }

        try {
            const response = await login({ userName, password });

            if (response.success) {
                // Guardamos los datos del usuario en el contexto
                const userData = {
                    id: response.data.id,
                    name: response.data.name,
                    email: response.data.email,
                    address: response.data.address,
                    phone: response.data.phone || ''
                };
                setUser(userData); // Actualizamos el contexto
                // Guardamos los datos del usuario en el localStorage
                localStorage.setItem('user', JSON.stringify(userData));

                console.log("Felicidades, lograste iniciar sesión. Y en teoría se guardó el usuario en el localStorage.");

                // Redirigir al perfil del usuario
                navigate('/perfil');
            } else {
                setErrorMessage(response.message || 'Datos incorrectos. Inténtelo nuevamente.');
            }
        } catch (error) {
            console.error('Error en el inicio de sesión:', error);
            setErrorMessage('Ocurrió un error. Por favor, inténtelo más tarde.');
        }
    };

    const handleGoogleLogin = async (response) => {
        try {
            const res = await fetch("https://backend-volt.onrender.com/auth/google", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_token: response.credential }),
            });

            const data = await res.json();

            if (data.data && data.data.email) {
                const email = data.data.email;
                const usuarioExiste = await verificarUsuarioPorCorreo(email);

                if (usuarioExiste) {
                    // Buscar el Customer completo en Frappe
                    const usuario = await getUserByEmail(email);

                    if (usuario) {
                        localStorage.setItem("user", JSON.stringify(usuario));
                        navigate("/perfil");
                    } else {
                        alert("No se pudo cargar el usuario.");
                    }
                } else {
                    // Usuario no existe
                    navigate("/registro-intermedio", { state: { googleData: data.data } });
                }
            } else {
                console.error("Respuesta inválida del servidor:", data);
            }
        } catch (error) {
            console.error("Error de autenticación:", error);
            alert("Hubo un error al intentar iniciar sesión con Google.");
        }
    };

    return (
        <div>
            <Header />
            <div className="aceternity-form-page">
                <div className="aceternity-form-wrapper">
                    <BorderGlow className="aceternity-glow-wrap" borderRadius={16} backgroundColor="transparent">
                    <div className="aceternity-form-card">
                        <h2 className="aceternity-form-title">Iniciar sesión</h2>
                        <p className="aceternity-form-subtitle">
                            Ingresá con tu cuenta Volteon para ver tus pedidos y acceder a promociones.
                        </p>

                        <div className="aceternity-form">
                            <div className="aceternity-form-row">
                                <TextField
                                    required
                                    label="Correo Electrónico"
                                    variant="filled"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    fullWidth
                                    autoComplete="off"
                                    sx={aceternityTextFieldSx}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <TextField
                                    label="Contraseña"
                                    type="password"
                                    variant="filled"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    fullWidth
                                    sx={aceternityTextFieldSx}
                                />
                            </div>

                            {errorMessage && (
                                <p style={{ color: "#ff6b6b", fontSize: "0.85rem", marginTop: 0 }}>
                                    {errorMessage}
                                </p>
                            )}

                            <button className="aceternity-btn-primary" onClick={handleLogin}>
                                Ingresar &rarr;
                            </button>

                            <div className="aceternity-divider" />

                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <GoogleOAuthProvider clientId="801798375542-2baifffveo060c865nmvrsia5ue85107.apps.googleusercontent.com">
                                    <GoogleLogin
                                        onSuccess={handleGoogleLogin}
                                        onError={() => console.log("Error de login con Google")}
                                        useOneTap // Esto habilita el inicio de sesión con un solo clic
                                    />
                                </GoogleOAuthProvider>
                            </div>

                            <Link
                                href="/crear-cuenta"
                                underline="hover"
                                sx={{ mt: 2, display: 'block', textAlign: 'center', color: 'rgba(255,255,255,0.6)' }}
                            >
                                ¿No tiene cuenta?
                            </Link>
                        </div>
                    </div>
                    </BorderGlow>
                </div>
            </div>
            <Footer />
        </div>
    );
}
